<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-account-tie"></i>
                <h2>Consultar Recibos</h2>
              </div>
            </div>
          </div>
          <form @submit.prevent.stop="loadRecibos">
            <div class="row">
              <div class="sm-12 md-4">
                <label>
                  Tipo de Período:
                  <select v-model="tipo_periodo">
                    <option value="V">Vencimento</option>
                    <option value="P">Pagamento</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  De:
                  <input type="date" lang="pt" v-model="data_de" />
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Até:
                  <input type="date" lang="pt" v-model="data_ate" />
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Agrupamento:
                  <select v-model="agrupamento">
                    <option value="Competência">Competência</option>
                    <option value="Imóvel">Imóvel</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Status do Recibo:
                  <select v-model="status">
                    <option value="">Todos</option>
                    <option value="Pago">Pago</option>
                    <option value="Em aberto">Em Aberto</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Imóveis:
                  <MultiSelect
                    v-model="codigo_imovel"
                    :options="
                      propriedades.map(
                        ({ CodImovel: value, Endereco: label }) => ({
                          value,
                          label,
                        })
                      )
                    "></MultiSelect>
                  <!--
                            <select v-model="codigo_imovel" multiple>
                            <option value="">Selecione</option>
                            <option
                                :value="propriedade.CodImovel"
                                v-for="propriedade in propriedades"
                                :key="propriedade.CodImovel"
                            >
                                {{ propriedade.Endereco }}
                            </option>
                        </select>
                        -->
                </label>
              </div>
            </div>
            <div class="row">
              <div class="sm-12 md-4">
                <button class="button primary" disabled v-if="gerando">
                  Gerando...
                </button>
                <button class="button primary" type="submit" v-else>
                  Gerar extrato
                </button>
              </div>
            </div>
            <div class="row">
              <div class="sm-12">
                <p></p>
                <p>
                  <span class="text-red">*</span>
                  Pagamento adiantado pela imobiliária, ainda não quitado pelo
                  inquilino
                  <br />
                  * Disponíveis apenas períodos relativos aos últimos 24 meses,
                  para períodos anteriores, solicitar diretamente ao seu(ua)
                  assessor(a).
                </p>
              </div>
            </div>
          </form>

          <div class="row" v-if="Recibos.length != 0">
            <div class="sm-12">
              <h2 class="button grey">
                Recibos de {{ data_de | date("dd/LL/yyyy") }} à
                {{ data_ate | date("dd/LL/yyyy") }}
              </h2>
              <p>
                <strong>Cliente:</strong>
                {{ cliente.nome }}
              </p>

              <Filial
                :filial="filial"
                :recibos="Recibos"
                :agrupamento="agrupamento"
                :tipo_periodo="TipoPeriodo"
                :propriedades="propriedades"
                v-for="filial in filiais"
                :key="filial.filial"></Filial>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "/plugins/api";
import { DateTime } from "luxon";
import Filial from "./consultar-recibos/filial.vue";
import Swal from "sweetalert2";
import MultiSelect from "/components/multiselect.vue";
export default {
  components: {
    Filial,
    MultiSelect,
  },
  data() {
    let lastDay = DateTime.local().daysInMonth;
    return {
      loading: false,
      gerando: false,
      errors: [],
      propriedades: [],
      tipo_periodo: "V",
      TipoPeriodo: "V",
      data_de: DateTime.local().toFormat("yyyy-LL-01"),
      data_ate: DateTime.local().toFormat(`yyyy-LL-${lastDay}`),
      agrupamento: "Competência",
      status: "",
      //codigo_imovel: "",
      codigo_imovel: [],
      recibos: [],
    };
  },
  filters: {
    number_format(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
  computed: {
    cliente() {
      return this.$store.state.cliente;
    },
    imoveis() {
      return this.$store.getters.imoveis;
    },
    filiais() {
      let filiais = [...new Set(this.Recibos.map(({ Filial }) => Filial))];
      return filiais;
    },
    Recibos() {
      let recibos = this.recibos;

      if (this.status != "") {
        recibos = recibos.filter(({ Status }) => Status == this.status);
      }

      return recibos;
    },
    imovel() {
      return this.$store.getters.imovel;
    },
    CodigoImovel() {
      if (!this.imovel) {
        return null;
      }
      return this.imovel.codigo;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
  },
  methods: {
    async loadPropriedades() {
      try {
        this.propriedades = [];

        let { data: propriedades } = await api.get("aluguel/propriedades");
        this.propriedades = propriedades;
      } catch (err) {
        this.errors = [...this.errors, err];
        console.error(err);
      }
    },
    async loadRecibos() {
      try {
        this.gerando = true;
        this.errors = [];
        this.recibos = [];

        let params = {};
        if (this.codigo_imovel.length != 0) {
          params.imoveis = this.codigo_imovel.join(",");
        }

        let { data: recibos } = await api.get(
          `aluguel/recibos/${this.tipo_periodo}/${this.data_de}/${this.data_ate}`,
          {
            params,
          }
        );

        this.TipoPeriodo = this.tipo_periodo;

        this.recibos = recibos;
      } catch (err) {
        let text = err.message || "Não foi possível carregar os recibos.";

        if (err.response && err.response.data) {
          text = err.response.data.error;
        }
        Swal.fire({
          icon: "error",
          title: "Oops",
          text,
        });
        console.error(err);
        this.errors = [...this.errors, err];
      }
      this.gerando = false;
    },
    async loadData() {
      this.loading = true;
      this.errors = [];

      await this.loadPropriedades();

      this.loading = false;
    },
  },
  watch: {
    CodigoImovel: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
  },
};
</script>
